import Icon from '@stone/ui/icon/Icon';
import React from 'react';
import { useTranslation } from 'react-i18next';
const A11YSubMenuBar = (props) => {
    const { t } = useTranslation();
    return (React.createElement("div", { className: "a11y-action-bar a11y-action-bar__menu" },
        React.createElement("div", { className: "container" },
            React.createElement("button", { className: "menu-close-button button--icon", onClick: props.onClick, "aria-label": t('button.close') },
                React.createElement(Icon, { family: "16", name: "close" })))));
};
export default A11YSubMenuBar;
